import { logUserDataResponseError, processFailedResponseStatus } from './processResponse';
import { format } from 'owa-localize';
import { makeDeleteRequest } from 'owa-ows-gateway';
import { UserDataItemResponse, UserDataResponseStatus } from '../data/schema/UserDataStoreSchema';

const USER_DATA_STORE_DELETE: string = 'ows/v1.5/UserDataStore/item/{0}';
const DELETE_KEY_VALUE_ACTION_NAME = 'DeleteUserDataValue';

/**
 * Delte a specific UserDataItem based on the item id.
 * @param itemId: The ID for the Item to delete.
 */
export async function deleteUserDataInfoService(itemId: string): Promise<UserDataItemResponse> {
    const apiUrl = format(USER_DATA_STORE_DELETE, itemId);
    try {
        const response = await makeDeleteRequest(
            apiUrl,
            null /* requestObject */,
            null /* correlationId */,
            true /* returnFullResponse */
        );
        if (response.ok) {
            return Promise.resolve(<UserDataItemResponse>{
                status: UserDataResponseStatus.SUCCESS,
            });
        } else {
            return Promise.resolve(<UserDataItemResponse>{
                status: processFailedResponseStatus(response, DELETE_KEY_VALUE_ACTION_NAME),
            });
        }
    } catch (error) {
        logUserDataResponseError(DELETE_KEY_VALUE_ACTION_NAME, error?.message);
        return Promise.resolve(<UserDataItemResponse>{
            status: UserDataResponseStatus.UNEXPECTED_ERROR,
        });
    }
}
